var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPortfolioNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_2143_1408)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M7.52165 8.88889H3.0772C1.85498 8.88889 0.85498 7.88889 0.85498 6.66667V2.22222C0.85498 1 1.85498 0 3.0772 0H7.52165C8.74387 0 9.74387 1 9.74387 2.22222V6.66667C9.74387 7.88889 8.74387 8.88889 7.52165 8.88889ZM3.0772 2.22222V6.66667H7.52165V2.22222H3.0772Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M18.6327 8.88889H14.1883C12.9661 8.88889 11.9661 7.88889 11.9661 6.66667V2.22222C11.9661 1 12.9661 0 14.1883 0H18.6327C19.855 0 20.855 1 20.855 2.22222V6.66667C20.855 7.88889 19.855 8.88889 18.6327 8.88889ZM14.1883 2.22222V6.66667H18.6327V2.22222H14.1883Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M7.52165 20H3.0772C1.85498 20 0.85498 19 0.85498 17.7777V13.3333C0.85498 12.1111 1.85498 11.1111 3.0772 11.1111H7.52165C8.74387 11.1111 9.74387 12.1111 9.74387 13.3333V17.7777C9.74387 19 8.74387 20 7.52165 20ZM3.0772 13.3333V17.7777H7.52165V13.3333H3.0772Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M18.6327 20H14.1883C12.9661 20 11.9661 19 11.9661 17.7777V13.3333C11.9661 12.1111 12.9661 11.1111 14.1883 11.1111H18.6327C19.855 11.1111 20.855 12.1111 20.855 13.3333V17.7777C20.855 19 19.855 20 18.6327 20ZM14.1883 13.3333V17.7777H18.6327V13.3333H14.1883Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2143_1408"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.85498)"
})))));
export default SvgIconPortfolioNew;